@if (visible && !carregando && pesquisa && form) {
  <div class="nps-banner">
    <form [formGroup]="form">
      @for (item of perguntasView; track item) {
        <div class="mb-3">
          <label class="block font-medium mb-3">
            {{ item.pergunta.ds_pergunta }}
            @if (item.tipo === 'texto') {
              <span class="nps-opcional">(opcional)</span>
            }
          </label>
          <!-- Escala NPS 0-10 -->
          @if (item.tipo === 'escala') {
            <div class="nps-escala-wrapper">
              <p-selectButton
                [formControlName]="item.controlName"
                [options]="escalaOptions"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
                class="nps-escala"
              ></p-selectButton>
              <div class="flex justify-content-between text-xs text-bluegray-300 mt-1">
                <span>Pouco provável</span>
                <span>Muito provável</span>
              </div>
            </div>
          }
          <!-- Múltipla escolha -->
          @if (item.tipo === 'alternativas') {
            <div class="flex flex-column gap-2">
              @for (alt of item.pergunta.alternativas; track alt) {
                <div class="flex align-items-center">
                  <p-radioButton
                    [inputId]="item.controlName + '_' + alt.cd_item_alternativa"
                    [formControlName]="item.controlName"
                    [value]="alt.cd_item_alternativa"
                  ></p-radioButton>
                  <label [for]="item.controlName + '_' + alt.cd_item_alternativa" class="ml-2">
                    {{ alt.ds_alternativa }}
                  </label>
                </div>
              }
            </div>
          }
          <!-- Comentário livre -->
          @if (item.tipo === 'texto') {
            <textarea
              pInputTextarea
              [formControlName]="item.controlName"
              [maxlength]="maxJustificativaChars"
              rows="3"
              class="w-full"
              placeholder="Deixe seu comentário"
            ></textarea>
            <div class="flex justify-content-end text-xs text-bluegray-300 mt-1">
              {{ (form.get(item.controlName)?.value?.length || 0) }}/{{ maxJustificativaChars }}
            </div>
          }
        </div>
      }
      <div class="flex justify-content-end gap-2 mt-3">
        <button
          pButton
          type="button"
          label="Agora não"
          class="p-button-sm p-button-text p-button-secondary"
          [disabled]="enviando"
          (click)="adiar()"
        ></button>
        <button
          pButton
          type="button"
          label="Enviar"
          class="p-button-sm"
          [disabled]="!form || form.invalid"
          [loading]="enviando"
          (click)="enviar()"
        ></button>
      </div>
    </form>
  </div>
}
